<template>
  <div class="col-sm-12 col-xs-12">
    <div class="panel panel-default border-panel card-view" :style="`min-height: ${panelHeight}`">
      <div class="panel-heading">
        <div class="pull-left">
          <h6 class="panel-title txt-dark">{{$t('app.dashboard.timeline') + ` (${title})`}}</h6>
        </div>
        <div v-if="listOptions" class="dropdown pull-right">
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="panel-wrapper collapse in">
        <div ref="notificationListContainer" class="panel-body" :style="`max-height: ${maxHeight}`">
          <div v-if="data.length > 0" class="streamline user-activity">
            <feed-card
              v-for="(dataItem,index) in data"
              :key="index"
              :cardData="dataItem"/>
          </div>
          <div v-else class="streamline user-activity no-data">
            <span v-if="data.length === 0" class="txt-dark">{{this.$t('app.dashboard.noData')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActivityFeedCard from "./ActivityFeedCard";

export default {
  name: "ActivityFeed",
  components: {
    'feed-card': ActivityFeedCard
  },
  props: {
    listOptions: {
      type: Array,
      required: false
    },
    data: {
      type: Array,
      required: true,
    },
    totalPages: {
			type: Number,
			required: true
    },
    panelHeight: {
      type: String,
      required: false
    },
    maxHeight: {
      type: String,
      required: false
    }
	},
  data() {
    return {
      isLoading: false,
			currentPageIndex: 1,
      showDropDown: false,
      title: this.$t('app.dashboard.overall')
    };
  },
  computed: {},
  created() {
    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  },
  mounted() {
		this.$refs.notificationListContainer.addEventListener( 'scroll', this.handleScroll, );
	},
  methods: {
    documentClick(e) {
      let el = this.$refs["dropdownMenu"];
      let elDefault = this.$refs["dropdownMenuDefault"];
      let elSelect = this.$refs["dropdownMenuSelect"];
      let target = e.target;
      if (el && el !== target && elDefault !== target && elSelect !== target && !el.contains(target)) {
        this.showDropDown = false;
      }
    },
    selectPartnerForNotification(id,name) {
      this.$emit('selectPartnerForNotification', id)
      this.showDropDown = false;
      this.title = name
      this.currentPageIndex = 1;
      this.isLoading = false;
    },
    selectDefaultForNotifications() {
      this.$emit('selectDefaultForNotifications')
      this.title = this.$t('app.dashboard.overall')
      this.showDropDown = false;
      this.currentPageIndex = 1;
      this.isLoading = false;
    },
    handleScroll() {
			if (!this.$refs.notificationListContainer) {
				return;
      }
      if ( this.$refs.notificationListContainer.scrollHeight - this.$refs.notificationListContainer.scrollTop <= this.$refs.notificationListContainer.offsetHeight * 1.1
      ) {
				this.loadNext();
				this.isLoading = true;
      } else {
				this.isLoading = false;
			}
		},
		loadNext() {
			if(this.totalPages === this.currentPageIndex) {
        return;
			}
			if (this.isLoading) {
        return;
      }
      this.currentPageIndex += 1
      this.$emit('loadNext',this.currentPageIndex)
		}
	}
};
</script>

<style lang="scss" scoped>

.panel-body {
    overflow-y: auto;
}
.menu {
  min-width: 200px;
  right: 0;
  position: absolute;
  padding: 5px;
  list-style: none;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.175);
  z-index: 1;
  max-height: 280px;
  overflow-y: auto;

  li {
    padding: 10px;
    border-bottom: 1px solid #eee;
    cursor: pointer;

    &:hover {
      background-color:rgba(33, 33, 33, 0.05);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/ActivityFeed.vue